import React, { useEffect, useState } from 'react'
import Logo_path from '../../Components/Logo_path'
import DescriptionMember from './DescriptionMember'
import RelatedVideosMember from './RelatedVideosMember'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function Memberprofile() {
  // const [isOnline, setIsOnline] = useState(navigator.onLine);

  // useEffect(() => {
  //   const handleOnlineStatusChange = () => {
  //     setIsOnline(navigator.onLine);
  //   };

  //   window.addEventListener('online', handleOnlineStatusChange);
  //   window.addEventListener('offline', handleOnlineStatusChange);

  //   return () => {
  //     window.removeEventListener('online', handleOnlineStatusChange);
  //     window.removeEventListener('offline', handleOnlineStatusChange);
  //   };
  // }, []);
  return (
    <>
        <div className='flex flex-col items-center' style={{height:'100%',width:'100%',fontFamily:'Ropa sans'}}>
      <div className='md:w-11/12 w-11/12 md:mb-10 mb-4'>
        <div><Logo_path AdminOrHome={'Home'} Directory={'Play'} /></div>
      </div>
      </div>

      <div>
        <div className='w-full h-full flex justify-center' style={{ fontFamily: 'Ropa sans' }}>
          <div className='w-10/12 h-full flex flex-row flex-wrap justify-between  mt-10 '>
            <div className='sm:w-3/12 w-full md:mb-0 mb-8'>
              <img className='w-full h-full rounded-lg' src="https://www.newsunzip.com/wp-content/uploads/2021/03/Pinarayi-Vijayan-Keralas-Chief-Minister-Filed-Nomination-Papers-from-Dharmadam-696x609.jpg" alt="Profile" />
              {/* skeleton demo */}
              {/* <div ><Skeleton className='h-96'/></div> */}
            </div>


            <div className='sm:w-8/12 w-full '>
              <DescriptionMember />
            </div>
          </div>
        </div>

        <div>

          <RelatedVideosMember /></div>
      </div>
      {/* :
     <div className="flex flex-col items-center justify-center h-screen">
      <img
        src="https://cdni.iconscout.com/illustration/premium/thumb/disconnected-4344475-3613903.png" // Replace with your illustration image
        alt="You are not connected"
        className="mb-8"
        style={{ width: '300px', height: '300px' }}
      />
      <h1 className="text-4xl font-bold text-gray-800 mb-4">You are not connected</h1>
      <p className="text-lg text-gray-600">Please check your internet connection and try again.</p>
    </div>
     } */}
    </>
  )
}

export default Memberprofile